export function openFromSelection(url: string): void {
  const target = new URL(url, window.location.origin);
  if (window.parent === window) {
    window.location.assign(target.href);
    return;
  }

  if (/^\/takeoff\/?$/.test(target.pathname) || target.searchParams.get('automate') === 'true') {
    if (!window.open(target.href, '_blank', 'noopener,noreferrer')) {
      const link = document.createElement('a');
      link.href = target.href;
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      link.textContent = 'Open in a new tab';
      link.style.cssText =
        'position:fixed;top:1rem;left:1rem;z-index:9999;background:white;padding:1rem;border:1px solid #888';
      document.body.appendChild(link);
      link.focus();
    }
    return;
  }

  if (/^\/design\/?$/.test(target.pathname)) {
    const projectId = target.searchParams.get('project_id')?.trim();
    if (projectId) {
      const parentOrigin = document.referrer
        ? new URL(document.referrer).origin
        : window.location.origin;
      if (
        parentOrigin !== window.location.origin &&
        !(import.meta.env.DEV && new URL(parentOrigin).hostname === 'localhost')
      )
        return;
      window.parent.postMessage(
        {
          type: 'selection:open-design',
          projectId,
        },
        parentOrigin,
      );
      return;
    }
  }
  window.location.assign(target.href);
}

